export default __webpack_public_path__ + "static/media/ic_login_hero_bar.8e67553b.svg";